module.exports = __webpack_public_path__ + "static/media/jo.8523785f.svg";